<template>
  <div class="h4 mb-10">{{ label }}</div>

  <div class="treatment-specialists__list">
    <e-checkbox
      v-for="(item, index) in items"
      :key="index"
      :model-value="groups[0].items[0].selectedOptions.includes(item)"
      :label="item"
      :disabled="isQuestionnaireSent"
      @update:model-value="onItemChange($event, item)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { TreatmentGroup } from '@/parts/content/types';
import { ECheckbox } from '@/core/components/ui';
import { useContentStore } from '@/parts/content/store';

defineProps<{
  label: string;
}>();

const groups = defineModel<TreatmentGroup[]>('groups', { required: true });

const { isQuestionnaireSent } = useContentStore();

const items = computed(() => groups.value?.flatMap((group) => group.items).flatMap((item) => item.options) || []);

const onItemChange = (state: boolean, item: string) => {
  if (state) {
    groups.value?.[0]?.items[0]?.selectedOptions.push(item);
  } else {
    groups.value?.[0]?.items[0]?.selectedOptions.splice(groups.value?.[0]?.items[0]?.selectedOptions.indexOf(item), 1);
  }
};
</script>

<style scoped lang="scss">
.treatment-specialists__list {
  display: grid;

  grid-template-columns: repeat(2, 1fr);
  gap: 16px 40px;

  @include xs {
    grid-template-columns: 1fr;
  }
}
</style>
